import camelcaseKeys from 'camelcase-keys';
import { API_AUTH_LOGIN_FAILURE, API_AUTH_LOGIN_SUCCESS, } from '@/actions/AuthActionsTs';
import { singletonScriptState } from '@/utils/window/SingletonScriptState';
import { API_AUTH_INFORMATION_SUCCESS, API_AUTH_REDIRECT_RESET, API_AUTH_REDIRECT_SAVE, } from '../actions/AuthActions';
import GoogleAnalytics from '../vendor/GoogleAnalytics';
import MouseFlowAnalytics from '../vendor/MouseFlowAnalytics';
const initialState = {
    payload: singletonScriptState.auth.value,
    redirectPath: '',
};
// eslint-disable-next-line default-param-last
export default (state = initialState, { payload, type }) => {
    switch (type) {
        case API_AUTH_LOGIN_SUCCESS: {
            const { auth } = payload;
            const decodePayload = {
                payload: camelcaseKeys(auth),
            };
            GoogleAnalytics.setLoginTypeDataLayer(decodePayload);
            MouseFlowAnalytics.setLoginType(decodePayload);
            return Object.assign(Object.assign({}, state), decodePayload);
        }
        case API_AUTH_LOGIN_FAILURE: {
            return Object.assign(Object.assign({}, state), { token: null });
        }
        case API_AUTH_REDIRECT_SAVE: {
            return Object.assign(Object.assign({}, state), { redirectPath: payload.pathname });
        }
        case API_AUTH_REDIRECT_RESET: {
            return Object.assign(Object.assign({}, state), { redirectPath: '' });
        }
        case API_AUTH_INFORMATION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { payload });
        }
        default: {
            return state;
        }
    }
};
